import { render, staticRenderFns } from "./ThgPriceCard.vue?vue&type=template&id=4b99bed6"
import script from "./ThgPriceCard.vue?vue&type=script&lang=ts"
export * from "./ThgPriceCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports